export const CHAT_CONFIG = {
  MAX_MESSAGE_LENGTH: 4000,
  MIN_PROMPT_LENGTH: 5,
  TYPING_DELAY: 1000,
  SCROLL_DELAY: 100,
  DEBOUNCE_DELAY: 300,
  RETRY_DELAY: 2000,
  MAX_RETRIES: 3,
} as const;

export const API_CONFIG = {
  TIMEOUT: 300000,
} as const;

const getApiBaseUrl = (): string => {
  const envUrl = __API_BASE_URL__;

  if (import.meta.env.DEV) {
    return '/';
  }

  if (!envUrl) {
    throw new Error('API_BASE_URL is required in production (set env var API_BASE_URL)');
  }

  return envUrl.replace(/\/$/, '');
};

/** Базовый URL для сервера авторизации/чатов. */
const getAuthApiBaseUrl = (): string => {
  if (import.meta.env.DEV) {
    return '/api/v1';
  }

  if (typeof __AUTH_API_BASE_URL__ === 'undefined' || !__AUTH_API_BASE_URL__) {
    throw new Error('AUTH_API_BASE_URL is required in production (set env var AUTH_API_BASE_URL)');
  }

  return __AUTH_API_BASE_URL__.replace(/\/$/, '');
};

export const API_BASE_URL = getApiBaseUrl();
export const AUTH_API_BASE_URL = getAuthApiBaseUrl();
export const DEFAULT_THREAD_ID = '1';
export const ENABLE_FILE_UPLOAD = __ENABLE_FILE_UPLOAD__;
export const ALLOWED_FILE_TYPES = __ALLOWED_FILE_TYPES__ ? __ALLOWED_FILE_TYPES__.split(',') : [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];
export const MAX_FILE_SIZE_MB = __MAX_FILE_SIZE_MB__ ? parseInt(__MAX_FILE_SIZE_MB__) : 10;
export const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024;


